import type { Routes } from '@angular/router';

import { LOGGED_OUT_ROUTES } from ':shared/routes/logged-out.routes';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => LOGGED_OUT_ROUTES,
    },
];
